import axios from 'axios';

const miDoctaApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_MIDOCTA_WS,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getConfiguracionMiDocta = async () => {
  const response = await miDoctaApi.get('/v1/ConfiguracionMiDocta');
  return response.data;
};
